(ns frontend.view.settings.sys-admin.event
  (:require
   [re-frame.core :as rf]
   [frontend.view.settings.sys-admin.sub :as sub]
   [frontend.controller.websocket.event :as ws]))

(rf/reg-event-fx
 ::toggle-marked-for-excision-ok
 (fn [{db :db} [_ tenant-id]]
   {:db (-> db
            (assoc-in [::sub/processing-toggle-marked-for-deletion?] false))}))

(rf/reg-event-fx
 ::toggle-marked-for-excision-failed
 (fn [{db :db} [_ tenant-id]]
   {:db (-> db
            (assoc-in [::sub/processing-toggle-marked-for-deletion?] false))}))

(rf/reg-event-fx
 ::toggle-marked-for-excision
 (fn [{db :db} [_ tenant-id suspended?]]
   {:db       (assoc-in db [::sub/processing-toggle-marked-for-deletion?] true)
    ::ws/send {:id         :tenant/update
               :body       {:db/id tenant-id
                            :tenant/marked-for-excision suspended?}
               :on-success [::toggle-marked-for-excision-ok tenant-id]
               :on-error   [::toggle-marked-for-excision-failed tenant-id]}}))

(rf/reg-event-fx
 ::toggle-suspended-ok
 (fn [{db :db} [_ tenant-id]]
   {:db (-> db
            (assoc-in [::sub/processing-toggle-suspended?] false))}))

(rf/reg-event-fx
 ::toggle-suspended-failed
 (fn [{db :db} [_ tenant-id]]
   {:db (-> db
            (assoc-in [::sub/processing-toggle-suspended?] false))}))

(rf/reg-event-fx
 ::toggle-suspended
 (fn [{db :db} [_ tenant-id suspended?]]
   {:db       (assoc-in db [::sub/processing-toggle-suspended?] true)
    ::ws/send {:id         :tenant/update
               :body       {:db/id tenant-id
                            :tenant/suspended suspended?}
               :on-success [::toggle-suspended-ok tenant-id]
               :on-error   [::toggle-suspended-failed tenant-id]}}))
